import React from "react";
import images from "@/assets/images";
import Button from "@/components/Button";
import Constants from "@/constants";
import classNames from "classnames";

interface HeaderBarProps {
  tabList: typeof Constants.TAB_LIST;
  curTab: Constants.ETabKey;
  setCurTab: (tab: Constants.ETabKey) => void;
}

const HeaderBar: React.FC<HeaderBarProps> = props => {
  return (
    <div className="flex w-full items-center justify-between px-[24px] py-[8px]">
      <img
        className="huyalogo h-[40px] w-[135px] cursor-pointer"
        src={images.hyLogo}
        alt="Logo"
        onClick={() => {
          window.open("https://www.huya.com/");
        }}
      />
      {/* 占位用 */}
      <div></div>
      <div className="navbar flex items-center">
        <div className="flex items-center">
          {props.tabList.map(item => (
            <div
              key={item.key}
              className={classNames(
                "mr-[32px] cursor-pointer py-[6px] text-[14px] font-[500] last-of-type:mr-0",
                item.key === props.curTab ? "text-[#ffe44d]" : "text-[#FFFFFF66]",
              )}
              onClick={() => props.setCurTab(item.key)}
            >
              {item.label}
            </div>
          ))}
        </div>
        <Button
          className="bg-primary ml-[32px] h-[44px] w-[124px] text-[14px] font-[500] text-[#2E3137]"
          onClick={() => {
            window.open("https://www.huya.com/");
          }}
        >
          回首页看直播
        </Button>
      </div>
    </div>
  );
};

export default HeaderBar;
